module.exports = __webpack_public_path__ + "static/media/orl-logo.702d5cd2.png";